import InviteToAppStatus from '@opsbase/lib-auth/InviteToAppStatus';
import StaffUserType from '@opsbase/lib-auth/StaffUserType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import App from '@opsbase/lib-system/App';
import { FeatureSets } from '@opsbase/lib-system/Features';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import EmailIcon from '@opsbase/web-icons/icons/EmailIcon';
import LogbookIcon from '@opsbase/web-icons/icons/LogbookIcon';
import OpsLogIcon from '@opsbase/web-icons/icons/OpsLogIcon';
import useNav from '@opsbase/web-nav/useNav';
import React, { useCallback, useState } from 'react';
import { IssuesLogOpener } from '../../shared/logopeners/IssuesLogOpener';
import OpsLogOpener from '../../shared/logopeners/OpsLogOpener';
import ItemMenu from './ItemMenu';
export const StaffMenu = React.memo((props) => {
    const { item, ...otherProps } = props;
    const [openOps, setOpenOps] = useState(false);
    const [openAssignedIssues, setOpenAssignedIssues] = useState(false);
    const [openRaisedIssues, setOpenRaisedIssues] = useState(false);
    const self = useSelf();
    const { hasFeature } = useSelfActions();
    const { goTo } = useNav();
    const handleToggleOpsOpener = useCallforward(v => () => setOpenOps(v), []);
    const handleToggleRaisedIssuesOpener = useCallforward(v => () => setOpenRaisedIssues(v), []);
    const handleToggleAssignedIssuesOpener = useCallforward(v => () => setOpenAssignedIssues(v), []);
    const handleAssignOp = useCallback(() => {
        goTo(Pages.OP_DEFINITIONS_ASSIGN, undefined, { staff: item });
    }, [goTo, item]);
    if (!item)
        return null;
    const canDeleteStaff = hasFeature(FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT_DELETION.key);
    const isPrimaryAdmin = item && item.staffType === StaffUserType.PRIMARYADMIN;
    const alreadyInvitedToApp = item && item.inviteToAppStatus !== InviteToAppStatus.INVITE_NOTSENT;
    const accepted = item && item.inviteToAppStatus === InviteToAppStatus.LOGGEDIN;
    const isSelf = self.id === item.id;
    return (React.createElement(React.Fragment, null,
        !!openOps && (React.createElement(OpsLogOpener, { dialog: true, staffId: item.id, onComplete: handleToggleOpsOpener(false) })),
        !!openRaisedIssues && (React.createElement(IssuesLogOpener, { dialog: true, createdBy: item.id, onComplete: handleToggleRaisedIssuesOpener(false) })),
        !!openAssignedIssues && (React.createElement(IssuesLogOpener, { dialog: true, assignedTo: item.id, onComplete: handleToggleAssignedIssuesOpener(false) })),
        React.createElement(ItemMenu, { id: item.id, options: [
                {
                    icon: EditIcon,
                    label: i18n.t('edit-staff'),
                    page: Pages.STAFF_EDIT,
                    variant: 'action',
                },
                {
                    icon: OpsLogIcon,
                    label: i18n.t('assign-op'),
                    onClick: handleAssignOp,
                    variant: 'good',
                },
                {
                    icon: OpsLogIcon,
                    label: i18n.t('view-ops'),
                    onClick: handleToggleOpsOpener(true),
                },
                {
                    icon: LogbookIcon,
                    label: i18n.t('issues-raised'),
                    onClick: handleToggleRaisedIssuesOpener(true),
                },
                {
                    icon: LogbookIcon,
                    label: i18n.t('issues-assigned'),
                    onClick: handleToggleAssignedIssuesOpener(true),
                },
                {
                    icon: EmailIcon,
                    label: i18n.t('invite-to-app'),
                    page: Pages.STAFF_INVITE,
                    variant: 'action',
                    visible: !(isSelf || accepted || alreadyInvitedToApp),
                },
                {
                    icon: EmailIcon,
                    label: i18n.t('resend-invite-to-app'),
                    page: Pages.STAFF_INVITE,
                    variant: 'action',
                    visible: !(isSelf || accepted || !alreadyInvitedToApp),
                },
                {
                    icon: DeleteIcon,
                    label: i18n.t('delete-staff'),
                    page: Pages.STAFF_DELETE,
                    variant: 'warn',
                    visible: canDeleteStaff && !(isSelf || isPrimaryAdmin),
                },
            ], ...otherProps })));
});
export default StaffMenu;
